// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2DTe0","empty":"ModalGraph_empty__TjePO"};